import { render, staticRenderFns } from "./crisisearlywarn.vue?vue&type=template&id=fb111894&scoped=true"
import script from "./crisisearlywarn.vue?vue&type=script&lang=js"
export * from "./crisisearlywarn.vue?vue&type=script&lang=js"
import style0 from "./crisisearlywarn.vue?vue&type=style&index=0&id=fb111894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb111894",
  null
  
)

export default component.exports